import { useState } from 'react'
import { Divider, Result, Progress, Button, Typography, Upload } from 'antd'
import {
  CheckOutlined
  CloseOutlined
  HistoryOutlined
  UploadOutlined
  QuestionOutlined
  LoadingOutlined
} from '@ant-design/icons'
import GeneralTemplate from './general'
import { getRandomUpload, getRandomInit } from '../funnies'
import { handleUpdatingStore } from './helpers'
import { pluginStatuses } from 'Services/ActionsPagesUtils'
import moment from 'moment'
import styled from 'styled-components'

{ Text } = Typography
{ Dragger } = Upload

StyledDragger = styled(Dragger)"""
  &&& {
    background: var(--backgroundColor);
    & > span {
      & > div {
        & > p {
          color: var(--primaryColor);
        }
      }
    }
  }
"""

UploadFile = GeneralTemplate({
  InputHandler: ({ inputState, setInputState, startPlugin, uploadFileProgress }) ->
    [initializing, setInitializing] = useState(false)

    handleUpload = ({ file, onSuccess }) ->
      if file
        file.uploadTime = moment()
        setInputState((prev = []) ->
          [file, prev...]
        )
        try
          setInitializing(true)
          onSuccess()
          setTimeout(->
            startPlugin({ file })
          , 1000)
        catch
          setInitializing(false)

    getStatus = (status) ->
      if status is pluginStatuses.ERRORED
        'danger'
      else
        status

    getStatusIcon = (status) ->
      if status is pluginStatuses.ERRORED
        <CloseOutlined />
      else if status is pluginStatuses.DONE
        <CheckOutlined />
      else
        <QuestionOutlined />

    if initializing
      <Result
        type='info'
        icon={<LoadingOutlined/>}
        title='Initializing...'
        subTitle={getRandomInit()}
      />
    else
      if uploadFileProgress <= 100
        <Result
          type='info'
          icon={<Progress type="circle" percent={uploadFileProgress} />}
          title='Uploading file...'
          subTitle={getRandomUpload()}
        />
      else
        <>
          <StyledDragger
            data-testid="upload-file"
            disabled={initializing or uploadFileProgress?}
            action={undefined}
            customRequest={handleUpload}
            maxCount={1}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
          </StyledDragger>
          {
            if inputState?.length > 0
              <>
                <Divider plain><HistoryOutlined /> Upload history</Divider>
                <div style={{ overflow: 'auto', maxHeight: '220px', padding: '0px 16px' }}>
                  {
                    inputState?.map((file) ->
                      date = file.uploadTime.format('HH:mm')
                      <div key={file.uid}>
                        <Text type={getStatus(file.status)}>
                          { getStatusIcon(file.status) } { file.name } ({ date })
                        </Text>
                      </div>
                    )
                  }
                </div>
              </>
          }
        </>

  ResponseHandler: ({ response: { log }, restart }) ->
    handleUpdatingStore(log)

    <Button
      shape="round"
      type="primary"
      onClick={restart}
      data-testid="upload-another-file"
    >
      Upload another file
    </Button>
})

export default UploadFile
